<template>
	<div>
		<nk-dropdown :ancestor-name="parentName" :model-value="dropdownValue" :data="dropdownData" :options="dropdownOptions" @update:modelValue="updateModelValue" ref="input" :tabindex="tabindex" :disabled="isDisable ? true : null"></nk-dropdown>
		<div class="w-100 d-flex justify-content-between" v-if="settings.showSelectedBalance && dropdownValue">
			<nk-label @click="turnOver" :modelValue="accessToSeeAmount ? dropdownValue.balance : '***'" :options="{ type: accessToSeeAmount ? 'balance' : 'string', nature: dropdownValue.accountNature }" class="font-weight-bold center-balance"></nk-label>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import Table from '~/components/table/grid'
	import AccountList from '~/views/accounts/account-selector'
	import $sc from '~/plugins/shortcut.collection.js'
	import { defineAsyncComponent } from 'vue'

	export default {
		name: 'dropdown-account',
		props: {
			data: { type: Array },
			modelValue: {},
			options: { type: Object },
			disabled: { type: Boolean, default: false },
			tabindex: {},
		},
		emits: ['update:modelValue', 'defaultAccountSet'],
		data() {
			return {
				dropValueSetByAutoAccount: false,
				preventRecursive: false,
				changeValueStatus: null,
				dropdownData: [],
				settings: {
					showSelectedBalance: true,
					formName: null,
					isDebtor: null,
					accountSelectorButton: false,
					autoAccountTypeKey: null,
					dropdownOptions: null,
					filterByOpposites: false,
					accountNature: null,
					loadOnMount: true,
					isSensitiveToFormNameChange: true
				},
				accountOppositeSides: {
					DebtorRemaining: ['CreditorRemaining', 'AlwaysCreditor'],
					CreditorRemaining: ['DebtorRemaining', 'AlwaysDebtor'],
					AlwaysDebtor: ['AlwaysCreditor', 'CreditorRemaining'],
					AlwaysCreditor: ['DebtorRemaining', 'AlwaysDebtor'],
					Undefined: ['AlwaysCreditor', 'AlwaysDebtor', 'DebtorRemaining', 'CreditorRemaining']
				},
				localValue: null,
				componentMounted: false,
			}
		},
		computed: {
			...mapGetters({
				findForm: 'forms/findFormByKey',
				account_leaves: 'accounts/leaves',
				account_all: 'accounts/all',
				getAutoAccountsItemsByKey: 'autoAccounts/getItemsByKey',
				checkAccountBalanceAccess: 'appContext/checkAccessAccountBalanceObserve',

			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.localValue = val
					this.$emit('update:modelValue', val)

					if (this.settings.onChangeHandler && typeof this.settings.onChangeHandler == 'function') {
						this.settings.onChangeHandler(val)
					}
				}
			},
			dropdownOptions() {
				if (!this.settings.dropdownOptions) return
				var sett = this.settings.dropdownOptions
				sett.disable = this.localDisabled
				if (sett.formName)
					sett.buttons = []
				return sett
			},
			autoAccountTypes() {
				let types = this.findForm(this.settings.formName)
					.types.filter((x) => x.isDebtor === this.settings.isDebtor)

				if (this.settings.autoAccountTypeKey) {
					if (typeof this.settings.autoAccountTypeKey === 'string')
						this.settings.autoAccountTypeKey = [this.settings.autoAccountTypeKey]
					types = types.filter((x) => this.settings.autoAccountTypeKey.indexOf(x.key) > -1)
				}

				return types
			},
			autoAccountTypeKeys() {
				let types = this.autoAccountTypes.reduce((arr, item) => {
					arr.push(item.key)
					return arr
				}, [])

				return types
			},
			localDisabled() {
				return this.componentMounted && this.dropdownData.length === 1 && (this.dropdownData[0].id === this.localValue?.id || !this.localValue)
			},
			isDisable() {
				return this.disabled || this.localDisabled
			},
			accessToSeeAmount() {
				return this.checkAccountBalanceAccess && !this.dropdownValue.balanceRestricted
			},

			parentName() {
				return this.$parent.$options.name
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
					if (val && oldVal && val.formName != oldVal.formName && this.settings.isSensitiveToFormNameChange) {
						this.findAndSetDropdownValueByForms()
						this.setDropdownData(this.findAccountsByKeys(this.autoAccountTypeKeys))
					}
				}
			},
			data: {
				immediate: true,
				deep: true,
				handler(val) {
					if (val)
						this.setDropdownData(val)
					else if (this.settings.formName) {
						this.setDropdownData(this.findAccountsByKeys(this.autoAccountTypeKeys))
					}
					else {
						this.setDropdownData(this.account_leaves)
					}
				}
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (val && val.id !== this.localValue?.id) {
						this.dropdownValue = val
						return
					}

					if (!val && this.settings.formName)
						this.findAndSetDropdownValueByForms()

					if (!val && !this.settings.formName)
						this.dropdownValue = null
				}
			},
			'$store.state.autoAccounts.autoAccounts': {
				deep: true,
				handler() {
					if (this.settings.formName) {
						this.setDropdownData(this.findAccountsByKeys(this.autoAccountTypeKeys))

						if (this.dropdownData.findIndex(x => x.id === this.localValue?.id) === -1) {
							this.findAndSetDropdownValueByForms()
						}
					}

				}
			}
		},
		created() {
			this.localValue = this.modelValue

			if (this.settings.formName) {
				this.setDropdownData(this.findAccountsByKeys(this.autoAccountTypeKeys))
			}

			this.settings.dropdownOptions = { ...this.settings.dropdownOptions, ...this.getDropDownOptions() }
		},
		mounted() {
			this.componentMounted = true
		},
		methods: {
			updateModelValue(val) {
				this.dropdownValue = val
			},
			turnOver() {
				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/turn-over.vue')),
					data: null,
					options: { filter: { accounts: [this.dropdownValue], level: !this.dropdownValue.hasChild ? 3 : this.dropdownValue.level } },

				})
					.then((result) => { })
					.catch((err) => { })
			},
			setDropdownData(accounts) {
				if (this.settings.filterByOpposites && this.settings.accountNature)
					this.dropdownData = accounts.filter(account => this.accountOppositeSides[this.settings.accountNature].indexOf(account.accountNature) > -1)
				else
					this.dropdownData = accounts
			},
			setDropdownValueByForm(account) {
				this.dropdownValue = account
				this.$emit('defaultAccountSet', account)
			},

			findAndSetDropdownValueByForms() {
				const targetAccounts = this.findAccountsByKeys(this.autoAccountTypeKeys)

				// let autoAccountTypes = this.autoAccountTypes
				if (targetAccounts.length === 1) {
					this.setDropdownValueByForm(targetAccounts[0])
				}
				else if (targetAccounts.filter(x => x.isDefault).length === 1) {
					const defaultAcc = targetAccounts.find(x => x.isDefault)
					this.setDropdownValueByForm(defaultAcc)
				}
				else if (this.autoAccountTypes.length === 1 && this.autoAccountTypes[0].defaultAccount) {
					const autoAccountType = this.autoAccountTypes[0]
					const defaultAccount = autoAccountType.defaultAccount

					if (defaultAccount && targetAccounts.some(account => account.id === defaultAccount.id)) {
						this.setDropdownValueByForm(defaultAccount)
					}
					else {
						this.setDropdownValueByForm(null)
					}
				}
				else {
					this.setDropdownValueByForm(null)
				}
			},

			getDropDownOptions() {
				return {
					rowIdentifier: 'id',
					display: (item) => `${item.name} (${item.accountingCode})`,
					remoteSearch: false,
					placeholder: this.$t('search'),
					selectorWidth: 420,
					searchableFields: ['accountingCode', 'name'],
					loadOnMount: this.settings.loadOnMount,
					onDestroyWithText: (dd, text) => {
						// this.findAccount(dd, text);
					},
					findExactMatch: this.findExactMatch,
					buttons: [{
						title: this.$t('list', { subject: this.$t('nav.accounts') }),
						shortcut: $sc.find('enter'),
						isPrimary: false,
						element: () => {
							return this.$el
						},
						visible: this.settings.accountSelectorButton,
						icon: 'list-ul',
						handle: (button, page, e) => {
							this.showAccounts()
						}
					}],
					selectorHeight: '100%',
					component: {
						type: 'ag-grid',
						// type: Table,
						options: {
							id: this.$options.name,
							columnDefs: [

								{
									field: 'accountingCode',
									headerName: this.$t('account.selector.table.c.accountingCode'),
									width: 20,
									// sort: 'asc',
								},
								{
									field: 'name',
									headerName: this.$t('account.selector.table.c.name'),
									width: 200,

									// type: 'rightAligned'
								},
								{
									field: 'parent',
									headerName: this.$t('account.selector.table.c.parent'),
									contentType: 'enum',
									valueFormatter: data => {
										return data.value?.name ? data.value.name : null
									},
									width: 150,

								}

							],
							rowSelection: {
								mode: 'singleRow'
							},
							cellSelectionAggReport: false,
							sideBar: 'none',
							enterToSelect: true,
							doubleClickedToSelect: true,
							pagination: false,
							fitToWidth: false
						}

						// options: {
						// 	colIndicatorBarEnabled: false,
						// 	searchable: false,
						// 	editable: false,
						// 	activeRowDisabled: true,
						// 	defaultSortByCols: [{ name: 'accountingCode', type: 'number' }],
						// 	columns: [
						// 		{
						// 			name: 'accountingCode',
						// 			title: this.$t('account.selector.table.c.accountingCode'),
						// 			width: 100,
						// 			pinnable: false,
						// 			resizable: true
						// 		},
						// 		{
						// 			name: 'name',
						// 			title: this.$t('account.selector.table.c.name'),
						// 			width: 'auto',
						// 			pinnable: false,
						// 			resizable: true,
						// 			align: 'right'
						// 		},
						// 		{
						// 			name: 'parent',
						// 			title: this.$t('account.selector.table.c.parent'),
						// 			width: 'auto',
						// 			align: 'right',
						// 			view: {
						// 				options: {
						// 					format: (item) => item.name
						// 				}
						// 			}
						// 		}
						// 	]
						// }
					}
				}
			},
			findAccountsByKeys(keys) {
				let accounts = []
				for (let key of keys) {
					accounts.push(...this.getAutoAccountsItemsByKey(key))
				}

				accounts = accounts.reduce((list, current) => {
					if (list.findIndex((x) => x.id === current.id) === -1) {
						list.push(current)
					}

					return list
				}, [])

				return accounts
			},
			showAccounts() {
				var that = this
				this.showModal({ component: AccountList, data: this.dropdownValue, options: { filterType: 'leaves' } })
					.then(function (result) {
						that.dropdownValue = result
						that.$refs.input.focusAndSelect()
					})
					.catch(err => {
					})
			},
			findExactMatch(list, text) {
				var filtered = list.filter(x => x.accountingCode === text)
				if (filtered.length === 1) {
					return filtered[0]
				}
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'm-account-dropdown-close',
					keyCode: [27], // 27:escape
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.modelValue)
							this.dropdownValue = this.modelValue
					}
				}) // arrow-up & escape
			}
		},
	}
</script>
<style></style>
